import React from "react";
import LogoIcon from "../../assets/icons/logo.svg";
import { useNavigate } from "react-router";
import LogoDark from "../../assets/icons/logolight.svg";

const Logo = ({ type }) => {
  const navigate = useNavigate();
  return (
    <div>
      <img
        onClick={() => navigate("/")}
        src={type === "light" ? LogoIcon : LogoDark}
        alt=""
        className="cursor-pointer"
      />
    </div>
  );
};

export default Logo;
